"use client";

import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { WaitlistModal } from "@/components/WaitlistModal";
import { isZenthorLaunched, zenthorCtaHref } from "@/lib/zenthor-launch";

// VOR-104 / KAN-724 — botão CTA que muda de comportamento no D-day do Zenthor:
//   - pré-lançamento (`NEXT_PUBLIC_ZENTHOR_LAUNCHED != "true"`): abre o
//     `WaitlistModal` para captação de e-mail
//   - pós-lançamento: vira link direto pro signup do produto
// Mantemos o componente como ponto único de cutover — toda CTA "Quero acesso"
// do site herda a troca sem precisar mexer arquivo a arquivo.

type WaitlistTriggerProps = {
  children: React.ReactNode;
  variant?: "primary" | "ghost";
  className?: string;
  source?: string;
  /**
   * Cupom opcional pré-aplicado quando o CTA vai direto pro signup.
   * Útil pra LANCAMENTO12M na campanha de lançamento.
   */
  coupon?: string | null;
};

export function WaitlistTrigger({
  children,
  variant = "primary",
  className,
  source = "modal",
  coupon,
}: WaitlistTriggerProps) {
  const [open, setOpen] = useState(false);

  if (isZenthorLaunched()) {
    return (
      <Button href={zenthorCtaHref(coupon)} variant={variant} className={className}>
        {children}
      </Button>
    );
  }

  return (
    <>
      <Button variant={variant} className={className} onClick={() => setOpen(true)}>
        {children}
      </Button>
      <WaitlistModal open={open} onClose={() => setOpen(false)} source={source} />
    </>
  );
}
